type UnifiedIconProps = {
  className?: string; // pass a class that sets --icon-color
};

export const UnifiedIcon = ({ className }: UnifiedIconProps) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ '--icon-color': 'currentColor' } as React.CSSProperties} // default
    >
      <defs>
        <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="gradient">
          <stop style={{ stopColor: 'var(--icon-color)', stopOpacity: 0.1 }} offset="0%" />
          <stop style={{ stopColor: 'var(--icon-color)', stopOpacity: 0.05 }} offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect fill="url(#gradient)" fillRule="nonzero" width="56" height="56" rx="12" />
        <path
          d="M16 16v21.333A2.667 2.667 0 0 0 18.667 40H40M36 34.667V24M29.333 34.667v-16M22.667 34.667v-4"
          stroke="var(--icon-color)"
          strokeWidth="2.667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
